import { IPageable, ISalonReviewsItem } from '@app/shared/models';

export interface ISalonReviews extends IPageable {
  reviews: ISalonReviewsItem[];
}
